<div class="flx-modal" role="dialog" aria-modal="true">
    <div class="flx-modal__header">
        <div class="with-desc">
            <h2>{{translate?.general.buttons.bulk.singular}} {{translate?.general.buttons.reAssign.singular}} {{translate?.setup.modules.types.fields.job.plural}} {{translate?.setup.modules.templates.messages.for}} {{selectedDayLabel | date: 'EEEE MMMM d, y' }}</h2>
        </div>
        <button class="icon-btn" aria-label="Close" [pTooltip]="translate?.general.buttons.close.singular"
            (click)="modalRef.hide()">
            <i class="fa-regular fa-xmark"></i>
        </button>
    </div>
    <div class="flx-modal__subheader">
        <h3>{{translate?.general.buttons.transfer.singular}} {{translate?.general.status.assigned.singular}} {{translate?.setup.modules.types.fields.job.plural | lowercase}} {{translate?.general.messages.from | lowercase}} {{translate?.general.messages.one | lowercase}} {{translate?.setup.users.users.label.singular | lowercase}} {{translate?.general.messages.toLower }} another.</h3>
    </div>
    <div class="flx-modal__body">
        <div class="status-field">
            <div class="mp-row">
                <form class="field-row--auto_range" [formGroup]="reassignUserForm">
                    <div class="status-field">
                        <span class="field-label ">Current {{translate?.setup.users.users.label.singular}}</span>
                        <p-dropdown formControlName="currentUser" [placeholder]="translate?.general.messages.none" [options]="userList" optionLabel="fullName" optionValue="id" [showClear]="true"></p-dropdown>
                        <div class="p-error text-10" *ngIf="reassignUserForm.get('currentUser')?.invalid && reassignUserForm.get('currentUser')?.touched">
                            <span >{{translate?.general.validationFE.requiredField}}</span>
                        </div>
                    </div>
                    <span class="divider-two"><i class="fa-solid fa-arrow-right"></i></span>
                    <div class="status-field">
                        <span class="field-label ">{{translate?.general.buttons.new.singular}} {{translate?.setup.users.users.label.singular}}</span>
                        <p-dropdown formControlName="newUser" [placeholder]="translate?.general.messages.none" [options]="newUserList" optionLabel="fullName" optionValue="id"></p-dropdown>
                        <div class="p-error text-10" *ngIf="reassignUserForm.get('newUser')?.invalid && reassignUserForm.get('newUser')?.touched">
                            <span >{{translate?.general.validationFE.requiredField}}</span>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>

    <div class="flx-modal__footer">
        <button type="button" class="custella-btn-white" (click)="modalRef.hide()">{{translate?.general.buttons.cancel.singular }}</button>
        <p-button styleClass="h-32" type="button" [label]="translate?.general.buttons.reAssign.singular" (onClick)="reassignUser()"></p-button>
    </div>
</div>